import axios from '../../services/httpService';
import { notificationMsg } from '../../utility/Notification';
import { API_URL } from '../../constants/ApiUrls';
import { CLEAR, CREATE_SKILL, DELETE_SKILL, GET_ALL_SKILLS, SEARCH_INPUT, SkILLS, SKILL_INPUT } from './Types';

export const handleSkillInput = (value) => (dispatch) => dispatch({ type: SKILL_INPUT, value });
export const handleCreateSkill = () => (dispatch) => dispatch({ type: CREATE_SKILL });

// Skill List
export const handleSkillsList = (value) => (dispatch) => dispatch({ type: SkILLS, value });
export const handleDeleteSkill = (value) => (dispatch) => dispatch({ type: DELETE_SKILL, value });
export const handleSkillSearchInput = (value) => (dispatch) => dispatch({ type: SEARCH_INPUT, value });
export const handleClearSkills = () => (dispatch) => dispatch({ type: CLEAR });

// Employee Skills
export const getAllSkills = () => async (dispatch) => {
  try {
    const response = await axios.get(API_URL.GET_SKILLS);
      dispatch(showLoading(false));
      dispatch({
        type: GET_ALL_SKILLS,
        payload: response.data,
      });
  } catch (error) {
    // will dispatch error message
    dispatch(showLoading(false));
  }
};

export const getSkillsSuggestion = (text) => async () => {
  try {
    const resp = await axios.post(API_URL.GET_SKILLS_FROM_JD, {text});
    if (resp?.status === 200) {
      return resp?.data?.tools;
    }
  } catch (error) {
      notificationMsg('error', error?.response?.data?.error);
  }
};

export const showLoading = (status) => {
  return {
    type: 'LOADING_ACTION',
    payload: status,
  };
};

export const updateSkillName = (name, id) => async (dispatch) => {
  try {
    const response = await axios.put(API_URL.UPDATE_SKILLS, { name, skill_id: id });
    dispatch(showLoading(false));
    dispatch({
      type: 'UPDATE_SKILL',
      payload: response.data,
    });
    if (response?.status === 200) {
      notificationMsg('success', 'Skill updated successfully');
    }
    dispatch(getAllSkills());
  } catch (error) {
    notificationMsg('error', error?.response?.data?.error || 'An error occurred');
  }
};

// Delete Skill
export const deleteSkill = ( id ) => async(dispatch) => {
  try {
    const response = await axios.delete(API_URL.DELETE_SKILLS, {params: { skill_id: id }});
    if (response?.status === 200) {
      notificationMsg('success', 'Skill deleted successfully');
    }
    dispatch(getAllSkills());
  } catch (error) {
    notificationMsg('error', error?.response?.data?.error);
  }
}

// Delete Multiple Skill
export const deleteMultipleSkills = (ids) => async (dispatch) => {
  try {
    const response = await axios.delete(API_URL.DELETE_MULTIPLE_SKILLS, { data: { skill_ids: ids } }); // Use data instead of params
    if (response?.status === 200) {
      notificationMsg('success', 'Skills deleted successfully');
    }
    dispatch(getAllSkills());
  } catch (error) {
    console.log("error: ", error);
    notificationMsg('error', error?.response?.data?.error);
  }
};